import Routing from "routing";

import { defineMessage as dm } from "@lingui/core/macro";

import type { Command } from "./types";

// The empty form has a page of its own, on the segment the router keeps for
// a client with no identifier yet.
export const createClientCommand: Command = {
  id: "create-client",
  label: dm`Create client`,
  keywords: ["client", "new", "add"],
  icon: "UserPlus",
  run: ({ close }) => {
    close();
    window.location.href = Routing.generate("azuris_client_index", {
      path: "new",
    });
  },
};
